var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.7,
    height: 29.7,
    fill: "#E6ECED",
    rx: 14.85
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#587E85",
    fillRule: "nonzero",
    d: "M16.426 11.935c.98.587 1.606 1.689 1.606 2.915 0 1.28-.707 2.466-1.802 3.023l-.254.13v4.947h-2.252v-4.948l-.254-.13c-1.095-.556-1.802-1.742-1.802-3.022 0-1.226.625-2.328 1.606-2.915v2.194l1.576 1.329 1.576-1.33zm.414-5.185l.185 2.336c.53.222 1.023.523 1.472.897l2.013-1 1.99 3.634-1.828 1.337c.04.296.061.597.061.896 0 .3-.02.6-.061.896l1.828 1.337-1.99 3.634-2.013-1c-.491.41-1.035.73-1.62.956v-2.086c.57-.345 1.055-.83 1.412-1.418.421-.692.643-1.494.643-2.319 0-1.87-1.132-3.514-2.817-4.092l-.59-.203v3.118l-.675.57-.675-.57v-3.118l-.59.203c-1.685.578-2.817 2.223-2.817 4.092 0 .825.222 1.627.643 2.319.357.588.842 1.073 1.413 1.418v2.086c-.586-.226-1.13-.546-1.62-.956l-2.014 1-1.99-3.634 1.828-1.337c-.04-.296-.061-.597-.061-.896 0-.3.02-.6.061-.896L7.2 12.617l1.99-3.634 2.013 1c.45-.374.942-.675 1.472-.897l.185-2.336h3.98z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAccess);
export default __webpack_public_path__ + "static/media/admin-access.dc7bca7bfc7941422e288bb3b93f7fde.svg";
export { ForwardRef as ReactComponent };